import { Stack, Tooltip } from '@mui/material';
import { type ReactElement } from 'react';

import { Text, type api } from 'common';

interface UserTooltipProps {
  user: api.User.User;
  children: ReactElement;
}

export function UserTooltip(props: UserTooltipProps) {
  const { user, children } = props;

  return (
    <Tooltip
      title={
        <Stack gap={1}>
          <Text variant="body2" color="inherit">
            <b>Last Name: </b>
            {user.lastName}
          </Text>
          <Text variant="body2" color="inherit">
            <b>First Name: </b>
            {user.firstName}
          </Text>
          <Text variant="body2" color="inherit">
            <b>Email: </b>
            {user.email}
          </Text>
        </Stack>
      }
    >
      {children}
    </Tooltip>
  );
}
